import React, { useEffect, useState } from "react";
import "./editProgramModal.css";
import { toast } from "react-toastify";
import axios from "axios";
import dummyImage from "../../../../Parent/parent-assets/images/about-us-banner.jpg";
import FadeLoader from "react-spinners/FadeLoader";
import GymCheerEditor from "../../ClassModals/GymCheerEditor";
import { getManageProgramDataNew } from "../../../adminApi/manageProgramData";
import { getCampProgramClassDetails } from "../../../adminApi/program";

const EditProgramModal = ({
  programName,
  programId,
  setShowCMSEditModal,
  prevImage,
  prevDescription,
  prevScheduleText,
  activeAccordion,
  getMasterProgramMenuData,
  setPrevImage,
  teamsAliasId,
}) => {
  const token = localStorage.getItem("access_token");
  const programIdNum = parseInt(programId);
  const [campMetaData, setCampMetaData] = useState({});
  const [selectedImage, setSelectedImage] = useState();
  const [selectedImageTwo, setSelectedImageTwo] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [image2, setImage2Image] = useState();
  const [frontImageSelectedImage, setFrontImageSelectedImage] = useState();
  const [frontImage, setFrontImage] = useState();
  const [images, setImages] = useState([]);
  const [formData, setFormData] = useState({});
  const [selectedDescImage, setSelectedDescImage] = useState();
  const [programDescription, setProgramDescription] = useState(prevDescription);
  const [scheduleText, setScheduleText] = useState(prevScheduleText);
  const [convertedImage, setConvertedImage] = useState();
  const [descImg, setDescImg] = useState();
  const [convertedDescImg, setConvertedDescImg] = useState();
  const [teamsData, setTeamsData] = useState();
  const [teamsGalleryImg, setTeamsGalleryImg] = useState();
  const [baseConvertedImage, setBaseConvertedImage] = useState();
  const [selectedHeaderFile, setSelectedHeaderFile] = useState([]);
  const [galleryLoader, setGalleryLoader] = useState(false);
  useEffect(() => {
    if (programName === "Teams") {
      getTeamProgramHandler();
      getGalleryInfoData();
      getLowerDescHandler();
    }
  }, []);

  const getLowerDescHandler = async () => {
    const response = await getCampProgramClassDetails(parseInt(teamsAliasId));
    setCampMetaData({
      camp_heading_first: response?.data?.data?.[0]?.camp_heading_first,
      camp_heading_second: response?.data?.data?.[0]?.camp_heading_second,
      subprogramdesc2: response?.data?.data?.[0]?.subprogramdesc2,
    });
  };

  const getGalleryInfoData = async () => {
    try {
      setGalleryLoader(true);
      const postData = {
        facility_id: parseInt(teamsAliasId),
      };
      const responseImage = await axios.post(
        process.env.REACT_APP_BASE_URL + `/admin/get_gallery`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTeamsGalleryImg(responseImage?.data?.data);
      setGalleryLoader(false);
    } catch (error) {
      console.error("Error while generating gallery info.", error);
      toast.error(error);
      setGalleryLoader(false);
    }
  };

  const getTeamProgramHandler = async () => {
    try {
      const response = await getManageProgramDataNew(token, programId);
      setTeamsData(response?.data);
      setPrevImage(response?.data?.[0]?.header_image);
      setProgramDescription(response?.data?.[0]?.description);
      setDescImg(response?.data?.[0]?.image);
    } catch (error) {
      toast.error(error);
    }
  };

  const handleProgramEventImage = async (e) => {
    setSelectedImage(e.target.value);
    e.preventDefault();
    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles?.length > 0) {
        const file = selectedFiles[0];
        const reader = new FileReader();

        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });

        // Start loading the file
        reader.readAsDataURL(file);

        // Wait for the FileReader to finish loading
        await loadPromise;

        // Create an image element to get the original dimensions
        const img = new Image();
        img.src = reader.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const desiredHeight = 780;
          const desiredWidth = 1920;
          // Set canvas dimensions to desired dimensions
          canvas.width = desiredWidth;
          canvas.height = desiredHeight;

          // Draw the image onto the canvas with the desired dimensions
          ctx.drawImage(img, 0, 0, desiredWidth, desiredHeight);

          // Convert the canvas content back to base64
          const resizedImageData = canvas.toDataURL("image/jpeg");

          const convertedFile = {
            image: resizedImageData,
          };

          const convertedFileName = {
            name: file.name,
          };

          setImages([convertedFile]);
          setFormData({ ...formData, file: convertedFileName });

          const postProgramImageData = {
            image: resizedImageData,
          };
          setConvertedImage(postProgramImageData?.image);
        };
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleFileChange = async (e, id) => {
    const sectionId = parseInt(id, 10);
    e.preventDefault();
    try {
      const selectedFiles = e.target.files;

      if (selectedFiles && selectedFiles?.length > 0) {
        const file = selectedFiles[0];
        setSelectedDescImage(file?.name);
        const reader = new FileReader();

        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });

        // Start loading the file
        reader.readAsDataURL(file);

        // Wait for the FileReader to finish loading
        await loadPromise;

        const img = new Image();
        img.src = reader.result;

        img.onload = async () => {
          // Set the desired height and width
          const desiredHeight = 412;
          const desiredWidth = 550;

          // Create a canvas element to draw the image with the new dimensions
          const canvas = document.createElement("canvas");
          canvas.height = desiredHeight;
          canvas.width = desiredWidth;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Convert the canvas content to a data URL
          const resizedImage = canvas.toDataURL("image/jpeg"); // You can also use 'image/png' for PNG format
          setImage2Image(resizedImage);
        };
      }
    } catch (error) {
      console.error(error);
    }
  };

  const descriptionHandler = async () => {
    try {
      if (teamsData?.[0]?.class_type === "weekly") {
        let postData;
        if (frontImage && convertedImage && convertedDescImg) {
          postData = {
            image_front: frontImage?.image,
            header_image: convertedImage,
            image: convertedDescImg,
            description: programDescription,
            subprogramId: parseInt(teamsData?.[0]?.id),
            camp_heading_first: campMetaData?.camp_heading_first,
            camp_heading_second: campMetaData?.camp_heading_second,
            subprogramdesc2: campMetaData?.subprogramdesc2,
          };
        } else if (frontImage && convertedImage) {
          postData = {
            image_front: frontImage?.image,
            header_image: convertedImage,
            description: programDescription,
            subprogramId: parseInt(teamsData?.[0]?.id),
            camp_heading_first: campMetaData?.camp_heading_first,
            camp_heading_second: campMetaData?.camp_heading_second,
            subprogramdesc2: campMetaData?.subprogramdesc2,
          };
        } else if (frontImage && convertedDescImg) {
          postData = {
            image_front: frontImage?.image,
            image: convertedDescImg,
            description: programDescription,
            subprogramId: parseInt(teamsData?.[0]?.id),
            camp_heading_first: campMetaData?.camp_heading_first,
            camp_heading_second: campMetaData?.camp_heading_second,
            subprogramdesc2: campMetaData?.subprogramdesc2,
          };
        } else if (frontImage) {
          postData = {
            image_front: frontImage?.image,
            description: programDescription,
            subprogramId: parseInt(teamsData?.[0]?.id),
            camp_heading_first: campMetaData?.camp_heading_first,
            camp_heading_second: campMetaData?.camp_heading_second,
            subprogramdesc2: campMetaData?.subprogramdesc2,
          };
        } else if (convertedImage && convertedDescImg) {
          postData = {
            header_image: convertedImage,
            image: convertedDescImg,
            description: programDescription,
            subprogramId: parseInt(teamsData?.[0]?.id),
            camp_heading_first: campMetaData?.camp_heading_first,
            camp_heading_second: campMetaData?.camp_heading_second,
            subprogramdesc2: campMetaData?.subprogramdesc2,
          };
        } else if (convertedImage) {
          postData = {
            header_image: convertedImage,
            description: programDescription,
            subprogramId: parseInt(teamsData?.[0]?.id),
            camp_heading_first: campMetaData?.camp_heading_first,
            camp_heading_second: campMetaData?.camp_heading_second,
            subprogramdesc2: campMetaData?.subprogramdesc2,
          };
        } else if (convertedDescImg) {
          postData = {
            image: convertedDescImg,
            description: programDescription,
            subprogramId: parseInt(teamsData?.[0]?.id),
            camp_heading_first: campMetaData?.camp_heading_first,
            camp_heading_second: campMetaData?.camp_heading_second,
            subprogramdesc2: campMetaData?.subprogramdesc2,
          };
        } else {
          postData = {
            description: programDescription,
            subprogramId: parseInt(teamsData?.[0]?.id),
            camp_heading_first: campMetaData?.camp_heading_first,
            camp_heading_second: campMetaData?.camp_heading_second,
            subprogramdesc2: campMetaData?.subprogramdesc2,
          };
        }
        setShowLoader(true);
        const response = await axios.post(
          process.env.REACT_APP_BASE_URL + `/admin/edit-sub-program-cms`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response?.status === 200 || response?.status === 201) {
          toast.success("Classes updated successfully.");
          setShowCMSEditModal(false);
          setShowLoader(false);
        }
        return;
      }
      let response;
      if (activeAccordion == 0) {
        let postData;

        if (convertedImage !== null || convertedImage !== undefined) {
          postData = {
            image: convertedImage,
            description: programDescription,
            programId: programId,
          };
        } else if (image2) {
          postData = {
            image: convertedImage ? convertedImage : prevImage?.image,
            image2: image2,
            description: programDescription,
            programId: programId,
          };
        }

        if (postData) {
          postData.schedule_text = scheduleText;
        }

        setShowLoader(true);
        response = await axios.post(
          process.env.REACT_APP_BASE_URL + `/admin/program_create_cms`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setShowLoader(false);
      } else if (activeAccordion == 1) {
        const postData = {
          image: convertedImage ? convertedImage : prevImage?.image,
          description: programDescription,
          age_range_id: programId,
        };
        setShowLoader(true);
        response = await axios.post(
          process.env.REACT_APP_BASE_URL + `/admin/age_range_cms`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setShowLoader(false);
      }

      setShowCMSEditModal(false);
      if (response?.status === 200 || response?.status === 201) {
        toast.success("Program updated successfully.");
        getMasterProgramMenuData();
      } else {
        toast.error("Error while updating the Program.");
      }
    } catch (error) {
      console.error("Error in descriptionHandler:", error);
    }
  };

  const frontImageHandler = async (e) => {
    setFrontImageSelectedImage(e.target.value);
    e.preventDefault();
    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles?.length > 0) {
        const file = selectedFiles[0];
        const reader = new FileReader();

        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });

        // Start loading the file
        reader.readAsDataURL(file);

        // Wait for the FileReader to finish loading
        await loadPromise;

        // Create an image element to get the original dimensions
        const img = new Image();
        img.src = reader.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const desiredHeight = 412;
          const desiredWidth = 635;
          // Set canvas dimensions to desired dimensions
          canvas.width = desiredWidth;
          canvas.height = desiredHeight;

          // Draw the image onto the canvas with the desired dimensions
          ctx.drawImage(img, 0, 0, desiredWidth, desiredHeight);

          // Convert the canvas content back to base64
          const resizedImageData = canvas.toDataURL("image/png");

          const convertedFile = {
            image: resizedImageData,
          };

          const convertedFileName = {
            name: file.name,
          };

          setImages([convertedFile]);
          setFormData({ ...formData, file: convertedFileName });

          const postProgramImageData = {
            image: resizedImageData,
          };
          setFrontImage(postProgramImageData);
        };
      }
    } catch (error) {
      console.error(error);
    }
  };

  const descImageHandler = async (e) => {
    setSelectedImageTwo(e.target.value);
    e.preventDefault();
    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles?.length > 0) {
        const file = selectedFiles[0];
        const reader = new FileReader();

        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });

        // Start loading the file
        reader.readAsDataURL(file);

        // Wait for the FileReader to finish loading
        await loadPromise;

        // Create an image element to get the original dimensions
        const img = new Image();
        img.src = reader.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const desiredHeight = 412;
          const desiredWidth = 635;
          // Set canvas dimensions to desired dimensions
          canvas.width = desiredWidth;
          canvas.height = desiredHeight;

          // Draw the image onto the canvas with the desired dimensions
          ctx.drawImage(img, 0, 0, desiredWidth, desiredHeight);

          // Convert the canvas content back to base64
          const resizedImageData = canvas.toDataURL("image/jpeg");

          const convertedFile = {
            image: resizedImageData,
          };

          const convertedFileName = {
            name: file.name,
          };

          setImages([convertedFile]);
          setFormData({ ...formData, file: convertedFileName });

          const postProgramImageData = {
            image: resizedImageData,
          };
          setConvertedDescImg(postProgramImageData?.image);
        };
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleFileChange2 = async (e, index) => {
    e.preventDefault();

    if (
      e.target.value?.split(".")?.[1]?.toLowerCase() === "jpg" ||
      e.target.value?.split(".")?.[1]?.toLowerCase() === "jpeg" ||
      e.target.value?.split(".")?.[1]?.toLowerCase() === "png"
    ) {
      try {
        const selectedFiles = e.target.files;
        if (selectedFiles && selectedFiles?.length > 0) {
          const file = selectedFiles[0];
          // setSelectedHeaderFile(file?.name);
          setSelectedHeaderFile((prevState) => {
            const tempIndex = [...prevState];
            tempIndex[index] = file?.name;
            return tempIndex;
          });
          const reader = new FileReader();

          // Create a Promise to wait for the FileReader to load
          const loadPromise = new Promise((resolve) => {
            reader.onloadend = () => {
              resolve();
            };
          });

          // Start loading the file
          reader.readAsDataURL(file);

          // Wait for the FileReader to finish loading
          await loadPromise;

          const img = new Image();
          img.src = reader.result;

          img.onload = async () => {
            // Set the desired height and width
            const desiredHeight = 2431;
            const desiredWidth = 3242;

            // Create a canvas element to draw the image with the new dimensions
            const canvas = document.createElement("canvas");
            canvas.height = desiredHeight;
            canvas.width = desiredWidth;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            // Convert the canvas content to a data URL
            const convertedFile = {
              image: canvas.toDataURL("image/jpeg"), // Use 'image/jpeg' for JPEG format
            };

            const convertedFileName = {
              name: file.name,
            };

            setBaseConvertedImage(convertedFile?.image);
            // setImages([convertedFile]);
            // setFormData({ ...formData, file: convertedFileName });
          };
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      toast.error(
        `Invalid format of image, image should only be JPEG,PNG and JPG`
      );
      return;
    }
  };

  const galleryImageHandler = async (fk_facilities, id) => {
    try {
      setGalleryLoader(true);
      const postData = {
        image: baseConvertedImage,
        fk_facilities: parseInt(fk_facilities),
        id: id,
      };
      const response = await axios.put(
        process.env.REACT_APP_BASE_URL + `/admin/update_gallery_image`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Image updated successfully.");
        setSelectedHeaderFile([]);
        setGalleryLoader(false);
        getGalleryInfoData();
      }
    } catch (error) {
      setGalleryLoader(false);
    }
  };

  const metaDataHandler = (e) => {
    const { name, value } = e.target;
    setCampMetaData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  return (
    <>
      <div
        className="Admin-modal Admin-modal--open"
        id="modalCategory"
        role="dialog"
      >
        <div className="Admin-modal__dialog Admin-modal__dialog--sm">
          <div
            className="Admin-modal__content"
            style={{ width: programName === "Teams" ? "350%" : "220%" }}
          >
            <div className="Admin-modal__head">
              <h2 className="Admin-modal__head--title">{programName}</h2>
              <h1
                className="closeProgramEditModal"
                onClick={() => setShowCMSEditModal(false)}
              >
                X
              </h1>
            </div>
            <div class="accordion__card__body">
              <div className="Admin-modal__body">
                {showLoader ? (
                  <div className="loader_container">
                    <FadeLoader
                      color="#5497c7"
                      cssOverride={{}}
                      height={50}
                      margin={8}
                      radius={9}
                      speedMultiplier={1}
                      width={11}
                    />
                  </div>
                ) : (
                  <div class="commonList">
                    <div class="commonList__row">
                      <div class="commonList__row__col">
                        <h4 class="label">Header Image:</h4>
                        <div class="cardbox">
                          <div class="browseBox">
                            <div class="browseFile">
                              <div class="browseFile__icon">
                                <svg
                                  width="33"
                                  height="33"
                                  viewBox="0 0 33 33"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                >
                                  <rect
                                    x="0.180664"
                                    width="32.53"
                                    height="32.53"
                                    fill="url(#pattern0)"
                                  />
                                  <defs>
                                    <pattern
                                      id="pattern0"
                                      patternContentUnits="objectBoundingBox"
                                      width="1"
                                      height="1"
                                    >
                                      <image xlinkHref="data:image/png;base64,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" />
                                    </pattern>
                                  </defs>
                                </svg>
                              </div>
                              <h4 class="browseFile__text">
                                Drag files to upload
                              </h4>
                              <p class="browseFile__ortext">or</p>
                              <input
                                class="hiddenInput"
                                id="BrowseFiles"
                                type="file"
                                onChange={(e) => handleProgramEventImage(e)}
                              />
                              <label for="BrowseFiles" class="browseBtn">
                                Browse Files
                              </label>
                              <h6 className="programSelectedFile">
                                {selectedImage?.split("\\")?.pop()}
                              </h6>
                              <div class="browseFileData">
                                <p class="browseFileData__text">
                                  Max File Size: <strong>10 MB</strong>
                                </p>
                                <p class="browseFileData__text">
                                  Supported file type:{" "}
                                  <strong>JPG,PNG,SVG</strong>
                                </p>
                              </div>
                              <div>
                                <img
                                  src={
                                    programName === "Teams"
                                      ? prevImage
                                      : prevImage?.image
                                      ? prevImage?.image
                                      : dummyImage
                                  }
                                  alt=""
                                  className="prevImage"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {programName === "Teams" && (
                        <div style={{ display: "flex", gap: "20px" }}>
                          <div class="commonList__row__col">
                            <h4 class="label">Descriptions Image:</h4>
                            <div class="cardbox">
                              <div class="browseBox">
                                <div class="browseFile">
                                  <div class="browseFile__icon">
                                    <svg
                                      width="33"
                                      height="33"
                                      viewBox="0 0 33 33"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlnsXlink="http://www.w3.org/1999/xlink"
                                    >
                                      <rect
                                        x="0.180664"
                                        width="32.53"
                                        height="32.53"
                                        fill="url(#pattern0)"
                                      />
                                      <defs>
                                        <pattern
                                          id="pattern0"
                                          patternContentUnits="objectBoundingBox"
                                          width="1"
                                          height="1"
                                        >
                                          <image xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFoElEQVR4nO2dW2icRRTHJznzbeodL4hWK4IXtIoggiJU8aWKt1YfRH0RtFIFCZj9zmyCFtcbYlHEB6soiPogVKEP6oOXChUsqBiotPuds4kNLakQhQYvrWhbzCfzZROyzaa7m73MfN+eH5y30J5z/jPzzeXMrFKCIAiCIAiCIAiCIAiCIHSOwviFgHRrv6EHteHHtaHhig0FBX4YCrQ2l6fL1X0xiAwdIAjpam14kza8XSMf1IbjBu0wIH0LyC/p4fIaEagVsHQeIL0AyD83IcCJDflXQHo1F5ZWt621ZJ1cWFoNSO9qQ/+2TYhFRjPa0Kc6jG5wHa+/hD+dAsgva+RjnROiZq/5TA3zxa7D94p+E92vDU91VYhqUQ4FhjcqFfepnqZYygHyFmdCmOOFoU/U8MQZqicxvBKQv3Mugqk2MMQ5E12meor8nlVtnT2Zdhv9FmD5GtUTDJcuAqQJ90nnOsMXHwwK0VUq0wyVzgJDe50n2zRsk3ZXQGWSYtyvDX3uQZLjZgwMj6rB8QGVNcDQi66Tq5crCvIWlU7iPvsxDMJoAxh6E5C/ASTShqddJ1W3KkqB1qq0oMPoZjD8hh1zXSdOd6yX0IQqjp6svGXjaJBsdRve5TpZunv2lPIRMNE9YHjMgwTFXbbf7UxReYPhlRrpCw8SEzsz5KeVDwCW1zd5OJRRo1/scO1UjMrx6Iz7ZLAXZhunIyniPjt9dZ0A7Z3Rh07kAKTX3QfPPtphQH4bDD+vkR/ThbHrVXHfio6KYT9eHgQep8aQj2jkrzTSEypfPqetYkBYvl0j/ec8SJNSQ/rH1gXk8uUrWlcjv2eVzKa4Xb3mmP0Gt9Rj7KF/CoN+TyO/3/UCicZtCkK6s2kxAOnelIlxBAyvm/ff8LpkLHftV02jGVuw13ghRXGHTsVJnqktRjpESYT5qKGFZT/SQ6kSA5denCWTko4W2rXs/zbbAeosADlKc89IW09JPvZLoZFuTI0Y2Pi2he89JTD8SG3HZw+XMiVGKkRB/nsAxy9R1cR9Tss42zhMpXT4+rLK2Vxh7ErvxcDWd1d97ilgojvmHZ29gZRtMXwXJSk1mlufgOF3sjhMpW/4im5KHNTIX3spGnbuEMjHnmI3IystxrPSTuxMz/C+pyD9lazgNdIfXomB3Tse9a6n2Iupdi7s3JGKBWG0QXWZwNCjruNeYJvsLOuoB44kNrB4kdRx7OUc13HPG/JWW1Hyp3NHKgaGN3f3nl9SxPGKR/HvUoA87tqR6lZCB+y8/ESmDX1cL9X2b+r+O0gHnMdbbVN2lrXTA0eaa0nIpXqC2L9x7WfzjZEP2W/IB84dEUHiSg6O2q495DrBIgjP5WBa2SW76wSLIDyXg/3JWbots3ed5GYMsvoNMbRjdkaCvNW9MyLI/F1GMHSX6ySLIBzbQpMFV5Z5v+tE6x4fsqruxGvDoWuHdA8LAkg/VEdQ3LfCw5Vr3CuC2JPbRUHYshQPHIt7UJBpNTh+eo0wkgqU7R44GPeWIPTMkoHYLXCvDq1M5gWZVIZPqxNMeb3PlzwhQ4I0fEJaeSfXucM6w4IA0lsNibEgqNdcO60zKggY/n4ZF0WTqvhnXTuvMyaIPRRU4d5z1XLRyIM+XReDFAsCSLvVk3T+ssWYF2W4vMY+K+E6IJ1uQbarkd1nqrYxQmcnFywdz8AgbYLYi6nIz3XsxwAg5Fvs3osIwvUbj+HRIB9d2xEhaghzt33GT3oI1xCCuD+kB+xOuuo29n1bW9/UrTph8HXIslWgyNugwLd58468/bkJ+7C9/dYA0o+deBUC/BFkKnno0/BmO1r4/SbjQoqlU+1Uz+6TBSFf16rlGvhBlqRhtOH/Ot4GRkqXqqGxC9TQ5EndSZ4gCIIgCIIgCIIgCIIgCIIgCIIgCIIgCJb/AX4RWhfolytoAAAAAElFTkSuQmCC" />
                                        </pattern>
                                      </defs>
                                    </svg>
                                  </div>
                                  <h4 class="browseFile__text">
                                    Drag files to upload
                                  </h4>
                                  <p class="browseFile__ortext">or</p>
                                  <input
                                    class="hiddenInput"
                                    id="BrowseFilesDescImg"
                                    type="file"
                                    onChange={(e) => descImageHandler(e)}
                                  />
                                  <label
                                    for="BrowseFilesDescImg"
                                    class="browseBtn"
                                  >
                                    Browse Files
                                  </label>
                                  <h6 className="programSelectedFile">
                                    {selectedImageTwo?.split("\\")?.pop()}
                                  </h6>
                                  <div class="browseFileData">
                                    <p class="browseFileData__text">
                                      Max File Size: <strong>10 MB</strong>
                                    </p>
                                    <p class="browseFileData__text">
                                      Supported file type:{" "}
                                      <strong>JPG,PNG,SVG</strong>
                                    </p>
                                  </div>
                                  <div>
                                    <img
                                      src={descImg}
                                      alt=""
                                      className="prevImage"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="commonList__row__col">
                            <h4 class="label">Front Image:</h4>
                            <div class="cardbox">
                              <div class="browseBox">
                                <div class="browseFile">
                                  <div class="browseFile__icon">
                                    <svg
                                      width="33"
                                      height="33"
                                      viewBox="0 0 33 33"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlnsXlink="http://www.w3.org/1999/xlink"
                                    >
                                      <rect
                                        x="0.180664"
                                        width="32.53"
                                        height="32.53"
                                        fill="url(#pattern0)"
                                      />
                                      <defs>
                                        <pattern
                                          id="pattern0"
                                          patternContentUnits="objectBoundingBox"
                                          width="1"
                                          height="1"
                                        >
                                          <image xlinkHref="data:image/png;base64,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" />
                                        </pattern>
                                      </defs>
                                    </svg>
                                  </div>
                                  <h4 class="browseFile__text">
                                    Drag files to upload
                                  </h4>
                                  <p class="browseFile__ortext">or</p>
                                  <input
                                    class="hiddenInput"
                                    id="BrowseFilesDescImg-11"
                                    type="file"
                                    onChange={(e) => frontImageHandler(e)}
                                  />
                                  <label
                                    for="BrowseFilesDescImg-11"
                                    class="browseBtn"
                                  >
                                    Browse Files
                                  </label>
                                  <h6 className="programSelectedFile">
                                    {frontImageSelectedImage
                                      ?.split("\\")
                                      ?.pop()}
                                  </h6>
                                  <div class="browseFileData">
                                    <p class="browseFileData__text">
                                      Max File Size: <strong>10 MB</strong>
                                    </p>
                                    <p class="browseFileData__text">
                                      Supported file type:{" "}
                                      <strong>JPG,PNG,SVG</strong>
                                    </p>
                                  </div>
                                  <div>
                                    <img
                                      src={teamsData?.[0]?.image_front}
                                      alt=""
                                      className="prevImage"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {(programName === "Camp" || programName === "camp") && (
                        <div class="commonList__row__col">
                          <h4 class="label"> Description Image:</h4>
                          <div class="cardbox">
                            <div class="browseBox">
                              <div class="browseFile">
                                <div class="browseFile__icon">
                                  <svg
                                    width="33"
                                    height="33"
                                    viewBox="0 0 33 33"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                  >
                                    <rect
                                      x="0.180664"
                                      width="32.53"
                                      height="32.53"
                                      fill="url(#pattern0)"
                                    />
                                    <defs>
                                      <pattern
                                        id="pattern0"
                                        patternContentUnits="objectBoundingBox"
                                        width="1"
                                        height="1"
                                      >
                                        <use
                                          xlinkHref="#image0_0_11529"
                                          transform="scale(0.01)"
                                        />
                                      </pattern>
                                      <image
                                        id="image0_0_11529"
                                        width="100"
                                        height="100"
                                        xlinkHref="data:image/png;base64,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"
                                      />
                                    </defs>
                                  </svg>
                                </div>
                                <h4 class="browseFile__text">
                                  Drag files to upload
                                </h4>
                                <p class="browseFile__ortext">or</p>
                                <input
                                  class="hiddenInput"
                                  id="BrowseFiles2"
                                  type="file"
                                  onChange={(e) =>
                                    handleFileChange(e, programIdNum)
                                  }
                                />

                                <label for="BrowseFiles2" class="browseBtn">
                                  Browse Files
                                </label>
                                <h6>{selectedDescImage}</h6>
                                <div class="browseFileData">
                                  <p class="browseFileData__text">
                                    Max File Size: <strong>10 MB</strong>
                                  </p>
                                  <p class="browseFileData__text">
                                    Supported file type:{" "}
                                    <strong>JPG,PNG,SVG</strong>
                                  </p>
                                </div>
                                <div>
                                  <img
                                    src={prevImage?.sub_image}
                                    alt=""
                                    className="prevImage"
                                  />
                                </div>
                              </div>
                              <div class="adminbutton__group"></div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div class="commonList__row">
                      <div class="cardbox">
                        <h4 class="label">Description:</h4>
                        <div class="adminform__group">
                          <textarea
                            class="adminform__textarea"
                            placeholder="write the contents here!"
                            value={programDescription}
                            onChange={(e) =>
                              setProgramDescription(e.target.value)
                            }
                          ></textarea>
                        </div>

                        {programName === "Camp" && (
                          <div class="adminform__group">
                            <h4 class="label">Camp Schedule Text:</h4>
                            <input
                              type="text"
                              class="adminform__input"
                              placeholder="e.g. All Camps Runs from July 1st - August 9th"
                              value={scheduleText || ""}
                              onChange={(e) => setScheduleText(e.target.value)}
                            />
                          </div>
                        )}

                        {programName === "Teams" && (
                          <div class="adminform__group">
                            <h4 class="label">Email:</h4>
                            <div style={{ width: "50%" }}>
                              <input
                                type="email"
                                name="camp_heading_second"
                                class="adminform__input"
                                value={campMetaData?.camp_heading_second}
                                onChange={(e) => metaDataHandler(e)}
                              />
                            </div>
                            <br />
                            <h4 class="label">Upper Description:</h4>
                            <textarea
                              class="adminform__textarea"
                              name="subprogramdesc2"
                              placeholder="write the contents here!"
                              value={campMetaData?.subprogramdesc2}
                              onChange={(e) => metaDataHandler(e)}
                            ></textarea>
                            <h4 class="label">Lower Description:</h4>
                            <textarea
                              class="adminform__textarea"
                              name="camp_heading_first"
                              placeholder="write the contents here!"
                              value={campMetaData?.camp_heading_first}
                              onChange={(e) => metaDataHandler(e)}
                            ></textarea>
                          </div>
                        )}
                        <div class="adminbutton__group">
                          <button
                            class="admibtn admibtn-blueOutline"
                            onClick={() => setShowCMSEditModal(false)}
                          >
                            Cancel
                          </button>
                          <button
                            class="admibtn admibtn-primary"
                            onClick={descriptionHandler}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {programName === "Teams" && (
                <div>
                  <hr />
                  <div class="commonList">
                    <div class="commonList__row ">
                      {teamsGalleryImg?.map((item, index) => (
                        <div>
                          <div class="commonList__row__col">
                            <h4 class="label">Gallery Img {index + 1}.</h4>
                            <div class="cardbox">
                              <div class="browseBox">
                                <div class="browseFile">
                                  <div class="browseFile__icon">
                                    <svg
                                      width="33"
                                      height="33"
                                      viewBox="0 0 33 33"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlnsXlink="http://www.w3.org/1999/xlink"
                                    >
                                      <rect
                                        x="0.180664"
                                        width="32.53"
                                        height="32.53"
                                        fill="url(#pattern0)"
                                      />
                                      <defs>
                                        <pattern
                                          id="pattern0"
                                          patternContentUnits="objectBoundingBox"
                                          width="1"
                                          height="1"
                                        >
                                          <image xlinkHref="data:image/png;base64,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" />
                                        </pattern>
                                      </defs>
                                    </svg>
                                  </div>
                                  <h4 class="browseFile__text">
                                    Drag files to upload
                                  </h4>
                                  <p class="browseFile__ortext">or</p>
                                  <input
                                    class="hiddenInput"
                                    id={`BrowseFiles-gal-${index}`}
                                    type="file"
                                    onChange={(e) =>
                                      handleFileChange2(e, index)
                                    }
                                  />
                                  <label
                                    for={`BrowseFiles-gal-${index}`}
                                    class="browseBtn"
                                  >
                                    Browse Files
                                  </label>
                                  <h6 className="programSelectedFile">
                                    {selectedHeaderFile?.[index]}
                                  </h6>
                                  <div class="browseFileData">
                                    <p class="browseFileData__text">
                                      Max File Size: <strong>10 MB</strong>
                                    </p>
                                    <p class="browseFileData__text">
                                      Supported file type:{" "}
                                      <strong>JPG,PNG,SVG</strong>
                                    </p>
                                  </div>
                                  {galleryLoader ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <FadeLoader
                                        color="#5497C7"
                                        height={21}
                                        margin={1}
                                      />
                                    </div>
                                  ) : (
                                    <div>
                                      <img
                                        src={item?.image}
                                        alt=""
                                        className="prevImage"
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <button
                            className="admibtn admibtn-primary"
                            style={{ float: "right", marginTop: "10px" }}
                            onClick={() =>
                              galleryImageHandler(item?.fk_facilities, item?.id)
                            }
                          >
                            Save
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              <hr />
              {programName === "Teams" && (
                <GymCheerEditor
                  classData={teamsData}
                  setShowCMSEditModal={setShowCMSEditModal}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProgramModal;
